<div id="student-tools" class="d-flex flex-column"
     *ngIf="whiteboard.sharedUsers?.has(localUser.id) || whiteboard.sharedUsers?.size === 0"
     [class.disabled]="classroom.selectedBoardTab === ViewportTab.ASSIGNMENT && !classroom.showPrivateWhiteboard">

  <div class="d-flex flex-wrap align-items-center">
    <button class="btn whiteboard-btn p-0" id="wb_btn_pointer"
            [class.active]="isPointerToolOn"
            (mousedown)="pointer()" title="Pointer">
      <img src="assets/img/whiteboard/pointer-icon.svg" height="24" alt="">
    </button>
    <button class="btn whiteboard-btn p-0 mr-0" id="wb_btn_select"
            [class.active]="isSelectToolOn"
            (mousedown)="select()" title="Select">
      <img src="assets/img/whiteboard/select.svg" height="24" alt="">
    </button>
    <button class="btn whiteboard-btn p-0 mr-0" id="wb_btn_eraser"
            [class.active]="isEraserToolOn"
            (mousedown)="eraser()" title="Eraser">
      <img class="no-drag" src="assets/img/whiteboard/eraser-tool.svg" height="24" alt="">
    </button>

    <div class="separator mx-2"></div>

    <button class="btn whiteboard-btn p-0" id="wb_btn_pen"
            [class.active]="isFreeToolOn"
            (mousedown)="free()" title="Pen">
      <img src="assets/img/whiteboard/pencil.svg" height="24" alt="">
    </button>

    <button class="btn whiteboard-btn p-0" id="wb_btn_text"
            [class.active]="isTextBoxToolOn"
            (mousedown)="textBox()" title="Text Box">
      <img src="assets/img/whiteboard/draw-textBox.svg" height="16" alt="">
    </button>
  </div>
</div>
